/*
 * @Description: 模板选择弹窗多语言
 * @FilePath: /weryai-web/locales/modules/templateModal.ts
 */
export default {
    zh: {
        imageEffects: '图片特效',
        videoEffects: '视频特效',
        cancel: '取消',
        save: '保存',
        noMore: '没有更多了',
        noData: '暂无数据',
        loading: '加载中...',
    },
    en: {
        imageEffects: 'Photo Effects',
        videoEffects: 'Video Effects',
        cancel: 'Cancel',
        save: 'Save',
        noMore: 'No more',
        noData: 'No data',
        loading: 'Loading...',
    },
    ja: {
        imageEffects: '画像エフェクト',
        videoEffects: '動画エフェクト',
        cancel: 'キャンセル',
        save: '保存',
        noMore: 'これ以上ありません',
        noData: 'データがありません',
        loading: '読み込み中...',
    },
    ko: {
        imageEffects: '사진 효과',
        videoEffects: '비디오 효과',
        cancel: '취소',
        save: '저장',
        noMore: '더 이상 없습니다',
        noData: '데이터 없음',
        loading: '로딩 중...',
    },
    tw: {
        imageEffects: '圖片特效',
        videoEffects: '影片特效',
        cancel: '取消',
        save: '儲存',
        noMore: '沒有更多了',
        noData: '暫無資料',
        loading: '載入中...',
    },
    es: {
        imageEffects: 'Efectos de imagen',
        videoEffects: 'Efectos de video',
        cancel: 'Cancelar',
        save: 'Guardar',
        noMore: 'No hay más',
        noData: 'Sin datos',
        loading: 'Cargando...',
    },
    fr: {
        imageEffects: 'Effets photo',
        videoEffects: 'Effets vidéo',
        cancel: 'Annuler',
        save: 'Enregistrer',
        noMore: 'Plus de contenu',
        noData: 'Aucune donnée',
        loading: 'Chargement...',
    },
    de: {
        imageEffects: 'Bildeffekte',
        videoEffects: 'Videoeffekte',
        cancel: 'Abbrechen',
        save: 'Speichern',
        noMore: 'Keine weiteren',
        noData: 'Keine Daten',
        loading: 'Lädt...',
    },
    ru: {
        imageEffects: 'Эффекты изображения',
        videoEffects: 'Видеоэффекты',
        cancel: 'Отмена',
        save: 'Сохранить',
        noMore: 'Больше нет',
        noData: 'Нет данных',
        loading: 'Загрузка...',
    },
    pl: {
        imageEffects: 'Efekty obrazu',
        videoEffects: 'Efekty wideo',
        cancel: 'Anuluj',
        save: 'Zapisz',
        noMore: 'Brak więcej',
        noData: 'Brak danych',
        loading: 'Ładowanie...',
    },
    pt: {
        imageEffects: 'Efeitos de imagem',
        videoEffects: 'Efeitos de vídeo',
        cancel: 'Cancelar',
        save: 'Salvar',
        noMore: 'Não há mais',
        noData: 'Sem dados',
        loading: 'Carregando...',
    },
    it: {
        imageEffects: 'Effetti immagine',
        videoEffects: 'Effetti video',
        cancel: 'Annulla',
        save: 'Salva',
        noMore: 'Non c\'è altro',
        noData: 'Nessun dato',
        loading: 'Caricamento...',
    },
    ar: {
        imageEffects: 'تأثيرات الصور',
        videoEffects: 'تأثيرات الفيديو',
        cancel: 'إلغاء',
        save: 'حفظ',
        noMore: 'لا مزيد',
        noData: 'لا توجد بيانات',
        loading: 'جارٍ التحميل...',
    },
    th: {
        imageEffects: 'เอฟเฟกต์ภาพ',
        videoEffects: 'เอฟเฟกต์วิดีโอ',
        cancel: 'ยกเลิก',
        save: 'บันทึก',
        noMore: 'ไม่มีข้อมูลเพิ่มเติม',
        noData: 'ไม่มีข้อมูล',
        loading: 'กำลังโหลด...',
    },
    da: {
        imageEffects: 'Billedeffekter',
        videoEffects: 'Videoeffekter',
        cancel: 'Annuller',
        save: 'Gem',
        noMore: 'Ikke mere',
        noData: 'Ingen data',
        loading: 'Indlæser...',
    },
    no: {
        imageEffects: 'Bildeeffekter',
        videoEffects: 'Videoeffekter',
        cancel: 'Avbryt',
        save: 'Lagre',
        noMore: 'Ikke mer',
        noData: 'Ingen data',
        loading: 'Laster...',
    },
    nl: {
        imageEffects: 'Afbeeldingseffecten',
        videoEffects: 'Video-effecten',
        cancel: 'Annuleren',
        save: 'Opslaan',
        noMore: 'Niet meer',
        noData: 'Geen gegevens',
        loading: 'Laden...',
    },
    id: {
        imageEffects: 'Efek gambar',
        videoEffects: 'Efek video',
        cancel: 'Batal',
        save: 'Simpan',
        noMore: 'Tidak ada lagi',
        noData: 'Tidak ada data',
        loading: 'Memuat...',
    },
    tr: {
        imageEffects: 'Görsel efektleri',
        videoEffects: 'Video efektleri',
        cancel: 'İptal',
        save: 'Kaydet',
        noMore: 'Daha fazla yok',
        noData: 'Veri yok',
        loading: 'Yükleniyor...',
    },
}
